import React, { useContext, useEffect, useState } from "react";

import { FormGroup, Modal } from "react-bootstrap";

import Logo from '../../../assets/images/wifi-attendance.svg'
import DatePicker from "react-datepicker";
import calendersvg from "../../../assets/images/calender_19.svg";
import calendersvg_dark from "../../../assets/images/calender_19_dark.svg";
import "react-datepicker/dist/react-datepicker.css";


import Form from "react-bootstrap/Form";

// import removeIcon from "../../../assets/images/removeIcon.svg";


import { ToWords } from "to-words";

import copyIcon from "../../../assets/images/Icon copy.png";


import { AppContext } from "../../../context/AppContext";
import ApiConfig from "../../../api/ApiConfig";
import { displayDateFormat, roundedOff, toFixedValue } from "../../../common";
import ProductTable from "./ProductTable";
import { PostCallWithAuthToken, putWithAuthCall, simpleGetCall, simpleGetCallWithToken } from "../../../api/ApiServices";
import { notifyError, notifySuccess } from "../../../toaster/notify";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { ToastMsg } from "../../TostMsg";

const SalesGoodsForm = ({
  newInvoice,
  handleInvoiceSearch,
  CopiedData,
  setInvoiceNo,
  receiveInvoiceId,
  invoiceNo,
  getInvoiceData,
  setIsView,
  setPrintButton,
  getCustomerInvoices,
  invoiceEditData,
  invoiceAction,
  setInvoiceAction,
  appSettings,
  setHideBothSide,
}) => {
  const userPermissions = JSON.parse(localStorage.getItem("user"));
  const permissions = userPermissions?.permissions;
  var commaNumber = require("comma-number");
  const {
    formFormat,
    setHideCopy,
    Dark,
    currentRoute,
    logo,
    setLogo,
    setSidebar,
    financialYearId,
    userData, ApiConfigg
  } = useContext(AppContext);

  const [backDropOpen, setBackDropOpen] = useState(false);
  const [invGenerateState, setInvGenerateState] = useState(0);

  const [products, setProducts] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [selectedDueDate, setSelectedDueDate] = useState(new Date());
  const [poDate, setPodate] = useState(new Date());
  const [addedNew, setAddedNew] = useState(false);
  const [hsnCodes, setHsnCodes] = useState([]);
  const [account, setAccount] = useState([]);
  const toWords = new ToWords();
  const [validated, setValidated] = useState(false);
  console.log("validated,", validated);
  const [productValidated, setProductValidated] = useState(false);
  const [nameList, setNameList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [newProduct, setNewProduct] = useState({
    productCode: "",
    productName: "",
    rate: 0,
    ledgerAccId: 0,
    taxRate: "",
    hsnCode: "",
    hsnId: 0,
    unit: "",
    unitId: 0,
  });
  // States

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const form = event.currentTarget;
  //   if (form.checkValidity() === false) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     setProductValidated(true);
  //   } else {
  //     PostCallWithAuthToken(
  //       ApiConfig.ADD_NEW_PRODUCT,
  //       JSON.stringify(newProduct)
  //     )
  //       .then((res) => {
  //         if (res.json.success) {
  //           notify("Product added successfully");
  //           setAddedNew(false);
  //           getProducts();
  //         } else {
  //           console.log(res);
  //           return;
  //         }
  //       })
  //       .catch((err) => console.log(err));
  //   }

  // };

  const [invoiceFormDetails, setInvoiceFormDetails] = useState({
    financialYearId: financialYearId,
    invoiceDate: new Date().toISOString().toString(),
    dueDate: new Date().toISOString().toString(),
    paymentTermId: 0,
    paymentTerms: "",
    cgst: 0,
    cgstAmount: 0,
    sgst: 0,
    sgstAmount: 0,
    igst: 0,
    igstAmount: 0,
    suppState: "",
    suppCountry: "",
    suppName: "",
    suppAddr: "",
    suppEmail: "",
    suppContactNo: "",
    suppGSTNo: "",
    suppPANNo: "",
    placeOfSupply: "",
    modeOfPay: "",
    chequeNo: "",
    bankName: "",
    custName: "",
    billAddr: "",
    billState: "",
    billCountry: "",
    billEmail: "",
    billContactNo: "",
    billGSTNo: "",
    billPANNo: "",
    billPincode: "",
    shipCustName: "",
    shipAddr: "",
    shipState: "",
    shipCountry: "",
    billCity: "",
    billPincode: "",
    shipCity: "",
    shipPincode: "",
    shipEmail: "",
    shipContactNo: "",
    shipGSTNo: "",
    shipPANNo: "",
    shipPincode: "",
    subTotal: 0,
    grossAmount: 0,
    gstAmount: 0,
    totalAmount: 0,
    PONo: "",
    podate: null,
    ewayBillNo: "",
    modeofTransport: "",
    vehicleNumber: "",
    roundOff: 0,
    isSEZEnabled: false,
    lutBondNo: "",
  });
  console.log("invoiceFormDetails=>", invoiceFormDetails);
  const [productDetails, setProductDetails] = useState([
    {
      hsnId: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnCode: "",
      qty: 0,
      rate: 0,
      gst: 0,
    },
  ]);

  let lengthOfPlaceOfSupply = invoiceFormDetails?.placeOfSupply.length;
  const isStateSame =
    invoiceFormDetails.suppGSTNo?.substring(0, 2) ===
    invoiceFormDetails.placeOfSupply.substring(
      lengthOfPlaceOfSupply - 2,
      lengthOfPlaceOfSupply
    );

  const [errMsg, setErrMsg] = useState({
    products: "",
  });

  const amountInWords = toWords.convert(
    invoiceFormDetails.totalAmount ? invoiceFormDetails.totalAmount : 0,
    {
      currency: true,
    }
  );

  // New Invoice or ClearData
  useEffect(() => {
    // let state =
    //   states &&
    //   states.filter(
    //     (state, i) =>
    //       state.code == invoiceFormDetails.suppGSTNo?.substring(0, 2)
    //   )[0];
    simpleGetCallWithToken(ApiConfig.GET_STATES)
      .then((res) => {
        simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
          .then((profileData) => {
            let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
            let state =
              res.data &&
              res.data.filter((state, i) => state.code == supplierGstNumber)[0];
            if (invoiceAction !== "edit") {
              setInvoiceFormDetails({
                ...invoiceFormDetails,
                invoiceNo: "",
                suppName: profileData.data.companyName
                  ? profileData.data.companyName
                  : "",
                suppAddr: profileData.data.address
                  ? profileData.data.address
                  : "",
                suppEmail: profileData.data.email ? profileData.data.email : "",
                suppContactNo: profileData.data.contactNo
                  ? profileData.data.contactNo
                  : "",
                suppGSTNo: profileData.data.gstNo ? profileData.data.gstNo : "",
                suppPANNo: profileData.data.panNo ? profileData.data.panNo : "",
                suppPincode: profileData.data.pincode
                  ? profileData.data.pincode
                  : "",
                invoiceDate: new Date().toISOString().toString(),
                dueDate: new Date().toISOString().toString(),

                cgst: 0,
                cgstAmount: 0,
                sgst: 0,
                sgstAmount: 0,
                igst: 0,
                igstAmount: 0,
                placeOfSupply: `${state?.name}-${state?.code}`,
                modeOfPay: "",
                chequeNo: "",
                bankName: "",
                custName: "",
                billAddr: "",
                billState: "",
                billCountry: "",
                billEmail: "",
                billContactNo: "",
                billGSTNo: "",
                billPANNo: "",
                billPincode: "",
                billCity: "",
                shipCustName: "",
                shipAddr: "",
                shipState: "",
                shipCountry: "",
                shipEmail: "",
                shipContactNo: "",
                shipGSTNo: "",
                shipPANNo: "",
                shipCity: "",
                shipPincode: "",
                subTotal: 0,
                grossAmount: 0,
                gstAmount: 0,
                totalAmount: 0,
                PONo: "",
                podate: null,
                ewayBillNo: "",
                modeofTransport: "",
                vehicleNumber: "",
                roundOff: 0,
                isSEZEnabled: false,
                lutBondNo: "",
              });
              setIsSezDeveloper(false);

              setProductDetails([
                {
                  hsnId: 0,
                  igst: 0,
                  igstAmount: 0,
                  sgst: 0,
                  sgstAmount: 0,
                  cgst: 0,
                  cgstAmount: 0,
                  discPer: 0,
                  discAmount: 0,
                  unitId: 15,
                  productName: "",
                  hsnCode: "",
                  qty: 0,
                  rate: 0,
                  gst: 0,
                },
              ]);

              setValidated(false);
              getInvoiceNo();
            }
          })
          .catch((err) => {
            console.error("catch error in new invoice action", err);
          });
      })
      .catch((error) => {
        console.log("catch error of States APIs,", error);
      });
  }, [newInvoice, invGenerateState]);

  useEffect(() => {
    let totalAmount = 0;
    let subTotal = 0;
    let igstAmount = 0;
    let cgstAmount = 0;
    let sgstAmount = 0;
    productDetails &&
      productDetails.length &&
      productDetails.map((item) => {
        igstAmount = igstAmount + parseFloat(item.igstAmount || 0);
        cgstAmount = cgstAmount + parseFloat(item.cgstAmount || 0);
        sgstAmount = sgstAmount + parseFloat(item.sgstAmount || 0);
        subTotal = subTotal + parseFloat(item.discAmount || 0);
        totalAmount =
          !isStateSame || invoiceFormDetails?.isSEZEnabled
            ? totalAmount + parseFloat(item.discAmount || 0) + parseFloat(item.igstAmount || 0)
            : totalAmount +
            parseFloat(item.discAmount || 0) +
            parseFloat(item.cgstAmount || 0) +
            parseFloat(item.sgstAmount || 0);
      });

    setInvoiceFormDetails({
      ...invoiceFormDetails,
      totalAmount: Math.floor(toFixedValue(totalAmount)),
      subTotal: toFixedValue(subTotal),
      igstAmount: toFixedValue(igstAmount),
      cgstAmount: toFixedValue(cgstAmount),
      sgstAmount: toFixedValue(sgstAmount),
      roundOff: appSettings.isRoundOff ? Number(roundedOff(totalAmount)) : 0,
    });
  }, [productDetails]);

  useEffect(() => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      placeOfSupply: CopiedData?.placeOfSupply ? CopiedData?.placeOfSupply : "",

      PONo: CopiedData?.poNo ? CopiedData?.poNo : "",
      ewayBillNo: CopiedData?.ewayBillNo ? CopiedData?.ewayBillNo : "",
      modeOfPay: CopiedData?.modeOfPay ? CopiedData?.modeOfPay : "",
      modeofTransport: CopiedData?.modeOfTransport
        ? CopiedData?.modeOfTransport
        : "",
      chequeNo: CopiedData?.chequeNo ? CopiedData?.chequeNo : "",
      bankName: CopiedData?.bankName ? CopiedData?.bankName : "",
      vehicleNumber: CopiedData?.vehicleNumber ? CopiedData?.vehicleNumber : "",

      // suppAddr :CopiedData?.suppAddr ? CopiedData?.suppAddr : "",
      // suppContactNo :CopiedData?.suppContactNo ? CopiedData?.suppContactNo : "",
      // suppEmail :CopiedData?.suppEmail ? CopiedData?.suppEmail : "",
      // suppGSTNo :CopiedData?.suppGSTNo ? CopiedData?.suppGSTNo : "",
      // suppName :CopiedData?.suppName ? CopiedData?.suppName : "",
      // suppPANNo :CopiedData?.suppPANNo ? CopiedData?.suppPANNo : "",

      custName: CopiedData?.custName ? CopiedData?.custName : "",
      billAddr: CopiedData?.billAddr ? CopiedData?.billAddr : "",
      billEmail: CopiedData?.billEmail ? CopiedData?.billEmail : "",
      billContactNo: CopiedData?.billContactNo ? CopiedData?.billContactNo : "",
      billGSTNo: CopiedData?.billGSTNo ? CopiedData?.billGSTNo : "",
      billPANNo: CopiedData?.billPANNo ? CopiedData?.billPANNo : "",
      billState: CopiedData?.billState ? CopiedData?.billState : "",
      shipCustName: CopiedData?.shipCustName ? CopiedData?.shipCustName : "",
      shipAddr: CopiedData?.shipAddr ? CopiedData?.shipAddr : "",
      shipEmail: CopiedData?.shipEmail ? CopiedData?.shipEmail : "",
      shipContactNo: CopiedData?.shipContactNo ? CopiedData?.shipContactNo : "",
      shipGSTNo: CopiedData?.shipGSTNo ? CopiedData?.shipGSTNo : "",
      shipPANNo: CopiedData?.shipPANNo ? CopiedData?.shipPANNo : "",
      igst: CopiedData?.igst ? CopiedData?.igst : 0,
      igstAmount: CopiedData?.igstAmount ? CopiedData?.igstAmount : 0,
      isSEZEnabled: CopiedData.isSEZEnabled ? CopiedData.isSEZEnabled : false,
      lutBondNo: CopiedData?.lutBondNo ? CopiedData?.lutBondNo : "",
      billCity: CopiedData?.billCity ? CopiedData?.billCity : "",
      billPincode: CopiedData?.billPincode ? CopiedData?.billPincode : "",
      shipCity: CopiedData?.shipCity ? CopiedData?.shipCity : "",
      shipPincode: CopiedData?.shipPincode ? CopiedData?.shipPincode : "",
    });

    if (CopiedData?.invoiceDetails) {
      setProductDetails([
        ...CopiedData?.invoiceDetails,
        {
          hsnId: 0,
          igst: 0,
          igstAmount: 0,
          sgst: 0,
          sgstAmount: 0,
          cgst: 0,
          cgstAmount: 0,
          discPer: 0,
          discAmount: 0,
          unitId: 15,
          productName: "",
          hsnCode: "",
          qty: 0,
          rate: 0,
          gst: 0,
        },
      ]);
    }
  }, [CopiedData]);

  const [units, setUnits] = useState([]);

  const getUnits = () => {
    simpleGetCallWithToken(ApiConfig.GET_UNITS)
      .then((res) => {
        if (res.success === true) {
          setUnits(res.data);
        } else {
          console.log("error res,", res);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getUnits();
    getStates();
    getHsnCodes();
    getAccounts();
    // getProducts();
    // getCustomerNames();
    fetchPaymentTerms();
    getInvoiceNo();
    // getProfileData();
  }, []);

  const [paymentTerms, setPaymentTerms] = useState([]);
  console.log("paymentTerms,", paymentTerms);
  const fetchPaymentTerms = async () => {
    try {
      const res = await simpleGetCallWithToken(ApiConfig.FETCH_PAYMENT_TERMS);
      console.log("res,", res);
      if (res.success) {
        setPaymentTerms(res.data);
      }
    } catch (error) {
      console.log("Catch error from payment terms API response,", error);
    }
  };

  const getStates = async () => {
    simpleGetCall(ApiConfig.GET_STATES)
      .then((res) => {
        console.log(res, 'statet');
        if (res?.success) {
          if (res.data !== null) setStates(res.data);
          setBackDropOpen(true);
          simpleGetCall(ApiConfig.GET_PROFILE_DATA).then(
            (profileData) => {
              setBackDropOpen(false);
              if (profileData.success === true) {
                let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
                let state =
                  res.data &&
                  res.data.filter(
                    (state, i) => state.code == supplierGstNumber
                  )[0];
                setLogo({
                  companyLogo: profileData.data.companyLogo,
                  signtureLogo: profileData.data.signature,
                  terms: profileData.data.terms,
                });
                localStorage.setItem(
                  "company_details",
                  JSON.stringify({
                    companyLogo: profileData.data.companyLogo,
                    signtureLogo: profileData.data.signature,
                    terms: profileData.data.terms,
                  })
                );
                if (invoiceAction === "edit") {
                  setIsSezDeveloper(
                    invoiceEditData?.isSEZEnabled ? true : false
                  );
                  setInvoiceNo(invoiceEditData?.invoiceNo);
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    id: invoiceEditData?.id ? invoiceEditData?.id : "",
                    invoiceNo: invoiceEditData?.invoiceNo
                      ? invoiceEditData?.invoiceNo
                      : "",
                    invoiceDate: invoiceEditData?.invoiceDate
                      ? invoiceEditData?.invoiceDate
                      : "",
                    dueDate: invoiceEditData?.dueDate
                      ? invoiceEditData?.dueDate
                      : "",
                    placeOfSupply: invoiceEditData?.placeOfSupply
                      ? invoiceEditData?.placeOfSupply
                      : "",
                    PONo: invoiceEditData?.poNo ? invoiceEditData?.poNo : "",
                    podate: invoiceEditData?.poDate
                      ? invoiceEditData?.poDate
                      : null,
                    ewayBillNo: invoiceEditData?.ewayBillNo
                      ? invoiceEditData?.ewayBillNo
                      : "",
                    modeOfPay: invoiceEditData?.modeOfPay
                      ? invoiceEditData?.modeOfPay
                      : "",
                    modeofTransport: invoiceEditData?.modeOfTransport
                      ? invoiceEditData?.modeOfTransport
                      : "",
                    chequeNo: invoiceEditData?.chequeNo
                      ? invoiceEditData?.chequeNo
                      : "",
                    bankName: invoiceEditData?.bankName
                      ? invoiceEditData?.bankName
                      : "",
                    vehicleNumber: invoiceEditData?.vehicleNumber
                      ? invoiceEditData?.vehicleNumber
                      : "",
                    custName: invoiceEditData?.custName
                      ? invoiceEditData?.custName
                      : "",
                    billAddr: invoiceEditData?.billAddr
                      ? invoiceEditData?.billAddr
                      : "",
                    billCity: invoiceEditData?.billCity
                      ? invoiceEditData?.billCity
                      : "",
                    billPincode: invoiceEditData?.billPincode
                      ? invoiceEditData?.billPincode
                      : "",
                    billEmail: invoiceEditData?.billEmail
                      ? invoiceEditData?.billEmail
                      : "",
                    billContactNo: invoiceEditData?.billContactNo
                      ? invoiceEditData?.billContactNo
                      : "",
                    billGSTNo: invoiceEditData?.billGSTNo
                      ? invoiceEditData?.billGSTNo
                      : "",
                    billPANNo: invoiceEditData?.billPANNo
                      ? invoiceEditData?.billPANNo
                      : "",
                    billState: invoiceEditData?.billState
                      ? invoiceEditData?.billState
                      : "",
                    billCity: invoiceEditData?.billCity
                      ? invoiceEditData?.billCity
                      : "",
                    billPincode: invoiceEditData?.billPincode
                      ? invoiceEditData?.billPincode
                      : "",
                    shipCustName: invoiceEditData?.shipCustName
                      ? invoiceEditData?.shipCustName
                      : "",
                    shipAddr: invoiceEditData?.shipAddr
                      ? invoiceEditData?.shipAddr
                      : "",
                    shipCity: invoiceEditData?.shipCity
                      ? invoiceEditData?.shipCity
                      : "",
                    shipPincode: invoiceEditData?.shipPincode
                      ? invoiceEditData?.shipPincode
                      : "",
                    shipEmail: invoiceEditData?.shipEmail
                      ? invoiceEditData?.shipEmail
                      : "",
                    shipContactNo: invoiceEditData?.shipContactNo
                      ? invoiceEditData?.shipContactNo
                      : "",
                    shipGSTNo: invoiceEditData?.shipGSTNo
                      ? invoiceEditData?.shipGSTNo
                      : "",
                    shipPANNo: invoiceEditData?.shipPANNo
                      ? invoiceEditData?.shipPANNo
                      : "",
                    shipCity: invoiceEditData?.shipCity
                      ? invoiceEditData?.shipCity
                      : "",
                    shipPincode: invoiceEditData?.shipPincode
                      ? invoiceEditData?.shipPincode
                      : "",
                    igst: invoiceEditData?.igst ? invoiceEditData?.igst : 0,
                    igstAmount: invoiceEditData?.igstAmount
                      ? invoiceEditData?.igstAmount
                      : 0,
                    isSEZEnabled: invoiceEditData?.isSEZEnabled ? true : false,
                    lutBondNo: invoiceEditData?.lutBondNo
                      ? invoiceEditData?.lutBondNo
                      : "",
                    suppName: invoiceEditData?.suppName
                      ? invoiceEditData?.suppName
                      : "",
                    suppAddr: invoiceEditData?.suppAddr
                      ? invoiceEditData?.suppAddr
                      : "",
                    suppEmail: invoiceEditData?.suppEmail
                      ? invoiceEditData?.suppEmail
                      : "",
                    suppContactNo: invoiceEditData?.suppContactNo
                      ? invoiceEditData?.suppContactNo
                      : "",
                    suppGSTNo: invoiceEditData?.suppGSTNo
                      ? invoiceEditData?.suppGSTNo
                      : "",
                    suppPANNo: invoiceEditData?.suppPANNo
                      ? invoiceEditData?.suppPANNo
                      : "",
                    suppPincode: invoiceEditData?.pincode
                      ? invoiceEditData?.pincode
                      : "",
                    paymentTermId: invoiceEditData.paymentTermId
                      ? invoiceEditData.paymentTermId
                      : 0,
                    paymentTerms: invoiceEditData.paymentTerms
                      ? invoiceEditData.paymentTerms
                      : "",
                  });

                  if (invoiceEditData?.invoiceDetails) {
                    setProductDetails([
                      ...invoiceEditData?.invoiceDetails,
                      {
                        id: 0,
                        hsnId: 0,
                        igst: 0,
                        igstAmount: 0,
                        sgst: 0,
                        sgstAmount: 0,
                        cgst: 0,
                        cgstAmount: 0,
                        discPer: 0,
                        discAmount: 0,
                        unitId: 15,
                        productName: "",
                        hsnCode: "",
                        qty: 0,
                        rate: 0,
                        gst: 0,
                      },
                    ]);
                  }
                } else {
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    suppName: profileData.data.companyName
                      ? profileData.data.companyName
                      : "",
                    suppAddr: profileData.data.address
                      ? profileData.data.address
                      : "",
                    suppEmail: profileData.data.email
                      ? profileData.data.email
                      : "",
                    suppContactNo: profileData.data.contactNo
                      ? profileData.data.contactNo
                      : "",
                    suppGSTNo: profileData.data.gstNo
                      ? profileData.data.gstNo
                      : "",
                    suppPANNo: profileData.data.panNo
                      ? profileData.data.panNo
                      : "",
                    placeOfSupply: state ? `${state.name}-${state.code}` : "",
                    suppPincode: profileData.data.pincode
                      ? profileData.data.pincode
                      : "",
                  });
                }
              }
            }
          );
        } else {
          setBackDropOpen(false);
          return;
        }
      })
      .catch((err) => console.log(err));
  };

  const getCustomerNames = async () => {
    // const res = await simpleGetCallWithToken(ApiConfig.GET_CUSTOMER_NAMES); old api
    const res = await simpleGetCallWithToken(ApiConfigg.GET_ZAMZAM_USERS);
    if (res.error) {
      console.log("Error responce,", res);
    } else {
      setNameList(res.data?.contacts);
    }
  };

  const getCustomerBillingData = async (billName) => {
    setBackDropOpen(true);
    let dataObj = {
      id: billName.id,
    };


    setInvoiceFormDetails({
      ...invoiceFormDetails,
      custName: billName.first_name,
      // billAddr: billName.billAddr,
      billContactNo: billName.phone_number,
      billEmail: billName.email,
      // billGSTNo: billName.gstNo,
      // billPANNo: billName.panNo,
      // placeOfSupply: state ? `${state.name}-${state.code}` : "",
      // billPincode: billName.pincode,
    });

    // try {
    //   const res = await PostCallWithAuthToken(
    //     ApiConfig.GET_CUSTOMER_BILLING_DATA,
    //     JSON.stringify(dataObj)
    //   );
    //   if (!res.error) {
    //     setBackDropOpen(false);

    //     let state =
    //       states &&
    //       states.filter(
    //         (state, i) => state.code == res.json.data.gstNo.substring(0, 2)
    //       )[0];

    //     if (res.json.success === true) {
    //       setInvoiceFormDetails({
    //         ...invoiceFormDetails,
    //         custName: res.json.data.customerName,
    //         billAddr: res.json.data.billAddr,
    //         billContactNo: res.json.data.contactNo,
    //         billEmail: res.json.data.email,
    //         billGSTNo: res.json.data.gstNo,
    //         billPANNo: res.json.data.panNo,
    //         placeOfSupply: state ? `${state.name}-${state.code}` : "",
    //         billPincode: res.json.data.pincode,
    //       });
    //     } else {
    //       console.log("Error res,", res);
    //     }
    //   } else {
    //     console.log("Error res,", res);
    //   }
    // } catch (error) {
    //   console.log("Error res,", error);
    // } finally {
    //   setBackDropOpen(false);
    // }
  };

  const getProducts = () => {
    simpleGetCallWithToken(ApiConfig.GET_PRODUCTS)
      .then((res) => {
        if (res.success && res.success === true) {
          setProducts(res.data);
        } else {
          console.log(res);
        }
      })
      .catch((err) => console.log(err));
  };

  const getHsnCodes = () => {
    simpleGetCallWithToken(ApiConfig.GET_HSNCODE)
      .then((res) => {
        setHsnCodes(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getAccounts = () => {
    simpleGetCallWithToken(ApiConfig.GET_ACCOUNT)
      .then((res) => {
        if (res.success === true) {
          setAccount(res.data);
        } else {
          console.log("error res,", res);
        }
      })
      .catch((err) => console.log(err));
  };

  const getInvoiceNo = () => {
    const body = {
      type: "SalesGoods",
    };

    PostCallWithAuthToken(ApiConfig.GET_INVOICENO, JSON.stringify(body))
      .then((res) => {
        if (res.json && res.json?.success === true) {
          setInvoiceNo(res.json.data);
        } else {
          console.log(res.json.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const getProfileData = () => {
    setBackDropOpen(true);
    simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
      .then((res) => {
        setBackDropOpen(false);
        setInvoiceFormDetails({
          ...invoiceFormDetails,
          suppName: res.data.companyName,
          suppAddr: res.data.address,
          // suppContactNo: "7745745522",
          suppContactNo: res.data.contactNo,
          suppGSTNo: res.data.gstNo,
          suppPANNo: res.data.panNo,
          suppPincode: res.data.pincode,
        });
      })
      .catch((err) => console.log(err));
  };

  const addNewRow = (e) => {
    e.preventDefault();
    let data = {
      id: 0,
      hsnId: 0,
      productId: 0,
      gst: 0,
      gstAmount: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnCode: "",
      qty: 0,
      rate: 0,
    };
    let newdata = [...productDetails, data];
    setProductDetails(newdata);
  };

  const goodsHandleChange = (name, event) => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      [name]: event.target.value,
    });
  };

  const getSelectedInvoiceId = (selectedId) => {
    receiveInvoiceId(selectedId);
  };

  const getFocus = () => {
    // if (
    //   invoiceFormDetails.totalAmount > 50000 &&
    //   invoiceFormDetails.ewayBillNo.trim() === ""
    // ) {
    //   document.getElementById("ewayBillNo").focus();
    //   return;
    // }
    if (invoiceFormDetails.placeOfSupply.trim() === "") {
      document.getElementById("placeOfSupply").focus();
      return;
    }
    if (invoiceFormDetails.modeOfPay.trim() === "") {
      document.getElementById("modeOfPay").focus();
      return;
    }
    if (
      invoiceFormDetails.chequeNo.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("chequeNo").focus();
      return;
    }
    if (
      invoiceFormDetails.bankName.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("bankName").focus();
      return;
    }
    if (invoiceFormDetails.modeofTransport.trim() === "") {
      document.getElementById("modeofTransport").focus();
      return;
    }
    if (
      invoiceFormDetails.vehicleNumber.trim() === "" &&
      invoiceFormDetails.modeofTransport === "By Road"
    ) {
      document.getElementById("vehicleNumber").focus();
      return;
    }
    // if (invoiceFormDetails.lutBondNo.trim() === "") {
    //   document.getElementById("lutBondNo")?.focus();
    //   return;
    // }
    if (invoiceFormDetails.custName.trim() === "") {
      document.getElementById("custName").focus();
      return;
    }
    if (invoiceFormDetails.billAddr.trim() === "") {
      document.getElementById("billAddr").focus();
      return;
    }
    if (invoiceFormDetails.billEmail.trim() === "") {
      document.getElementById("billEmail").focus();
      return;
    }
  };
  // Invoice Form Submit API call function
  const submitInvoiceForm = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      notifyError("Please Fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount !== 0
    ) {
      setErrMsg({ ...errMsg, products: "Please enter product details" });
      notifyError("Please Fill Product Details");
    } else {
      Swal.fire({
        title: "Do you want to submit the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      })
        .then((result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let filteredProductList = productDetails.filter((item, index) => {
              if (item.productName || item.hsnCode || item.cgst || item.sgst) {
                return item;
              }
            });
            var payLoad = {
              ...invoiceFormDetails,
              invoiceDetails: filteredProductList,
              invoiceNo: invoiceNo,
            };
            PostCallWithAuthToken(ApiConfig.SALESGOOD, JSON.stringify(payLoad))
              .then((res) => {
                console.log(res, 'hi');
                if (res.json && res.json?.success === true) {

                  setLoading(false);
                  getSelectedInvoiceId(res.json.data.id);
                  setHideCopy(true);
                  getInvoiceNo();
                  setInvGenerateState(invGenerateState + 1);
                  ToastMsg('success', res?.json?.message)

                  // getCustomerNames();
                  getCustomerInvoices("");
                  getInvoiceData(res.json.data.id);
                  setIsView(true);
                  setHideCopy(true);
                  setPrintButton(true);

                  setHideBothSide({
                    lg: "8",
                    displayBlock: "",
                  });
                  setSidebar(true);
                } else {
                  setLoading(false);
                  ToastMsg("error", "Something went wrong");
                }
              })
              .catch((err) => {
                console.log(err);

                setLoading(false);
              });
          }
        });
    }
  };

  const updateInvoice = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      notifyError("Please fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount == 0
    ) {
      setErrMsg({ ...errMsg, products: "Please enter product" });
      notifyError("Please fill all required fields");
    } else {
      Swal.fire({
        title: "Do you want to update the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          let filteredProductList = productDetails.filter((item, index) => {
            if (item.productName || item.hsnCode || item.cgst || item.sgst) {
              return item;
            }
          });

          const updatedProductList = filteredProductList.map(item => ({
            ...item,
            gst: Number(item.gst) > 0 ? item.gst : 0
          }));
          var data = {
            ...invoiceFormDetails,
            invoiceDetails: updatedProductList
          };
          putWithAuthCall(
            ApiConfig.UPDATE_SALES_GOODS_INVOICE,
            JSON.stringify(data)
          )
            .then((res) => {
              if (res.success === true) {
                setInvoiceAction("submitInvoice");
                setInvGenerateState(invGenerateState + 1);
                setLoading(false);
                notifySuccess(res.message);
                setHideCopy(true);
                // getCustomerNames();
                getCustomerInvoices("");
                getInvoiceData(res.json.data.id);
                getSelectedInvoiceId(res.json.data.id);
                setHideBothSide({
                  lg: "8",
                  displayBlock: "",
                });
                setSidebar(true);
                setProductDetails([
                  {
                    hsnId: 0,
                    igst: 0,
                    igstAmount: 0,
                    sgst: 0,
                    sgstAmount: 0,
                    cgst: 0,
                    cgstAmount: 0,
                    discPer: 0,
                    discAmount: 0,
                    unitId: 15,
                    productName: "",
                    hsnCode: "",
                    qty: 0,
                    rate: 0,
                    gst: 0
                  },
                ]);
              } else {
                setLoading(false);
                ToastMsg('error', "Something Went Wrong")
              }
            })
            .catch((err) => {
              setLoading(false);
            });
        }
      });
    }
  };

  const DeleteHandler = (index) => {
    const productList = [...productDetails];
    productList.splice(index, 1);
    setProductDetails(productList);
  };
  const [isSezDeveloper, setIsSezDeveloper] = useState(false);

  const getDetailsByGstNumber = (gstNumber, gstType) => {
    if (gstNumber.length === 15) {
      setBackDropOpen(true);
      simpleGetCallWithToken(
        ApiConfig.GET_GSTIN_DETAILS + `/${gstNumber.toUpperCase()}`
      )
        .then((res) => {
          setBackDropOpen(false);
          let gstDetail = res.data.lstAppSCommonSearchTPResponse[0];
          setIsSezDeveloper(gstDetail?.dty === "SEZ Developer" ? true : false);
          let address =
            gstDetail.pradr.addr.flno +
            "," +
            " " +
            gstDetail.pradr.addr.bno +
            "," +
            " " +
            gstDetail.pradr.addr.bnm +
            "," +
            " " +
            gstDetail.pradr.addr.st +
            "," +
            " " +
            gstDetail.pradr.addr.loc +
            "," +
            " " +
            gstDetail.pradr.addr.stcd;

          if (gstType === "shipGSTNumber") {
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              shipCustName: gstDetail.tradeNam,
              shipAddr: address,
              shipGSTNo: gstDetail.gstin,
              shipPANNo: gstDetail.gstin.substring(2, 12),
              shipPincode: gstDetail.pradr.addr.pncd,
              shipCity: gstDetail.pradr.addr.loc,
            });
          } else {
            let state =
              states &&
              states.filter(
                (state, i) => state.code == gstDetail.gstin.substring(0, 2)
              )[0];
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              custName: gstDetail.tradeNam,
              billAddr: address,
              billState: "",
              billGSTNo: gstDetail.gstin,
              billPANNo: gstDetail.gstin.substring(2, 12),
              // placeOfSupply: state ? `${state.name}-${state.code}` : "",
              billPincode: gstDetail.pradr.addr.pncd,
              billCity: gstDetail.pradr.addr.loc,
              isSEZEnabled:
                gstDetail?.dty === "SEZ Developer" || "SEZ Unit" ? true : false,
            });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const copyAndClearBillingAddress = (type) => {
    if (type === "clearShipment") {
      setInvoiceFormDetails({
        ...invoiceFormDetails,
        shipCustName: "",
        shipAddr: "",
        shipCity: "",
        shipContactNo: "",
        shipGSTNo: "",
        shipPANNo: "",
        shipPincode: "",
        shipEmail: "",
      });
    } else if (type === "clearBilling") {
      let state =
        states &&
        states.filter(
          (state, i) =>
            state.code == invoiceFormDetails.suppGSTNo?.substring(0, 2)
        )[0];

      setInvoiceFormDetails({
        ...invoiceFormDetails,
        custName: "",
        billAddr: "",
        billCity: "",
        billContactNo: "",
        billGSTNo: "",
        billPANNo: "",
        billPincode: "",
        billEmail: "",
        placeOfSupply: `${state?.name}-${state?.code}`,
        isSEZEnabled: false,
        lutBondNo: "",
      });
      setIsSezDeveloper(false);
    } else {
      setInvoiceFormDetails({
        ...invoiceFormDetails,
        shipCustName: invoiceFormDetails.custName,
        shipAddr: invoiceFormDetails.billAddr,
        shipContactNo: invoiceFormDetails.billContactNo,
        shipGSTNo: invoiceFormDetails.billGSTNo,
        shipPANNo: invoiceFormDetails.billPANNo,
        shipCity: invoiceFormDetails.billCity,
        shipPincode: invoiceFormDetails.billPincode,
        shipEmail: invoiceFormDetails.billEmail,
      });
    }
  };

  return (
    <main id="main-TemplateLogoBottom">
      {/* <BackDropLoader backDropOpen={backDropOpen} /> */}
      <Form
        noValidate
        validated={validated}
        onSubmit={invoiceAction === "edit" ? updateInvoice : submitInvoiceForm}
      >
        <FormGroup>
          <div id="main-default-edit-form">
            <div className="main-invoice-card">
              <div className="invoice-inner-main">
                {/* ========================================================== */}
                <div className="text-invoice-main">
                  {formFormat === "center" && (
                    <div className="left">
                      <label
                        className="logo-top-left d-block"
                        htmlFor="uploadLogo1"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="middle-top-logo text-center pb-3 mt-4">
                          {/* <div className="right-logo logo-back">
                          <div className="img-right img">
                            <img src={rb_logo} alt="" />
                          </div>
                        </div> */}
                          <div className="right-logo logo-back">
                            {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                            <div style={{ textAlign: "center" }}>
                              {/* <input
                              type="file"
                              name=""
                              id="uploadLogo1"
                              className="d-none"
                            /> */}
                              {Dark === "lightMode" ? (
                                <img
                                  src={userData?.CompanyLogo}
                                  alt=""
                                  onError={(e) => e.target.src = Logo}
                                />
                              ) : (
                                <img
                                  src={userData?.CompanyLogo}
                                  alt=""
                                  onError={(e) => e.target.src = Logo}
                                />
                              )}
                              {/* <br /> */}
                              {/* <label
                              style={{ fontSize: "11px" }}
                              htmlFor=""
                              className="text-auth"
                            >
                              Upload your logo here
                            </label> */}
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  )}
                  <div className="text-invoice-inner">
                    {formFormat === "right" && (
                      <div className="right-logo logo-back">
                        {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                        <div className="right-logo logo-back">
                          {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                          <div style={{ textAlign: "center" }}>
                            {/* <input
                            type="file"
                            name=""
                            id="uploadLogo1"
                            className="d-none"
                          /> */}
                            {Dark === "lightMode" ? (
                              <img
                                src={userData?.CompanyLogo}
                                alt=""
                                onError={(e) => e.target.src = Logo}
                              />
                            ) : (
                              <img
                                src={userData?.CompanyLogo}
                                alt=""
                                onError={(e) => e.target.src = Logo}
                              />
                            )}
                            {/* <br /> */}
                            {/* <label
                            style={{ fontSize: "11px" }}
                            htmlFor=""
                            className="text-auth"
                          >
                            Upload your logo here
                          </label> */}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="right">
                      <div className="invoice-text-right">
                        <div className="text-invoice-heading">
                          <label htmlFor="">Tax Invoice</label>
                        </div>
                        <div className="invoice-number">
                          <label htmlFor="" className="key">
                            Invoice No.
                          </label>
                          <label htmlFor="" className="value ms-4">
                            {invoiceFormDetails?.invoiceNo
                              ? invoiceFormDetails?.invoiceNo
                              : invoiceNo}{" "}
                          </label>
                          {/* <div className="input-with-pencile">
                          <input
                            name="invoiceNo"
                            type="text"
                            className="form-control mb-1 invoice-number-style"
                            value={invoiceFormDetails.invoiceNo}
                            placeholder="Invoice Number"
                            required
                            onChange={(e) => {
                              goodsHandleChange("invoiceNo", e);
                              props.setInvoiceNo(e.target.value)
                              setErrMsg({ ...errMsg, invoiceNo: "" });
                            }}
                          />
                          <img className="pen" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please Enter Invoice Number
                          </div>
                        </div> */}
                        </div>

                        <div className="date">
                          <div>
                            <label htmlFor="" className="key">
                              Date :{" "}
                            </label>
                          </div>

                          <div className="d-flex align-items-center">
                            <DatePicker
                              selected={
                                invoiceFormDetails.invoiceDate
                                  ? new Date(invoiceFormDetails.invoiceDate)
                                  : new Date()
                              }
                              value={
                                invoiceFormDetails.invoiceDate
                                  ? displayDateFormat(
                                    appSettings.dateFormat,
                                    invoiceFormDetails.invoiceDate
                                  )
                                  : ""
                              }
                              onChange={(date) => {
                                // setInvoiceDate(date);
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  invoiceDate: new Date(date)
                                    .toISOString()
                                    .toString(),
                                });
                              }}
                              showYearDropdown
                              required
                              // dateFormat={"MM/dd/yyyy"}
                              name="invoiceDate"
                              placeholderText="Choose a date"
                              className="cald form-control form-control-date ms-2"
                            />
                            {Dark === "lightMode" ? (
                              <img
                                src={calendersvg}
                                className="calendarI"
                                alt=""
                              />
                            ) : (
                              <img
                                src={calendersvg_dark}
                                className="calendarI"
                                alt=""
                              />
                            )}{" "}
                            {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                          </div>
                        </div>

                        <div className="date" id="deu-date">
                          <div>
                            <label htmlFor="" className="key">
                              Due Date :{" "}
                            </label>
                          </div>

                          <div className="d-flex align-items-center">
                            <DatePicker
                              selected={
                                invoiceFormDetails.dueDate
                                  ? new Date(invoiceFormDetails.dueDate)
                                  : new Date()
                              }
                              value={
                                invoiceFormDetails.dueDate
                                  ? displayDateFormat(
                                    appSettings.dateFormat,
                                    invoiceFormDetails.dueDate
                                  )
                                  : ""
                              }
                              onChange={(date) => {
                                // setSelectedDueDate(date);
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  dueDate: new Date(date)
                                    .toISOString()
                                    .toString(),
                                });
                              }}
                              showYearDropdown
                              required
                              // minDate={new Date(invoiceDate)}
                              // dateFormat="dd/MM/yyyy"
                              name="dueDate"
                              placeholderText="Choose a date"
                              className="cald form-control form-control-date ms-2"
                            />
                            {Dark === "lightMode" ? (
                              <img
                                src={calendersvg}
                                className="calendarI"
                                alt=""
                              />
                            ) : (
                              <img
                                src={calendersvg_dark}
                                className="calendarI"
                                alt=""
                              />
                            )}
                            {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                          </div>
                        </div>

                        {/* <div className="date" id="deu-date">
                          <label htmlFor="" className="key">
                            Payment Terms:
                          </label>
                          <div className="d-flex align-items-center">
                            <select
                              id="paymentTerms"
                              className="cald form-control form-control-date ms-2"
                              aria-label="Default select example"
                              name="paymentTerms"
                               //value={invoiceFormDetails.paymentTerms}
                              
                              onChange={(e) => {
                                const values = JSON.parse(e.target.value);
                                console.log("value,", values.days);

                               const { payTerms, id } = values;
                         
                                // Assuming payTerms is a number representing the days
                                const paymentTermDays = parseInt(payTerms, 10);

                                // Assuming invoiceDate is a Date object or a string that can be converted to a Date object
                                const invoiceDate = new Date(
                                  invoiceFormDetails.invoiceDate
                                );

                                // Calculate the due date by adding the payment term days
                                const dueDate = new Date(invoiceDate);
                                dueDate.setDate(
                                  dueDate.getDate() + paymentTermDays
                                );

                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  paymentTermId: values.id,
                                  paymentTerms: values.payTerms,
                                  dueDate: dueDate.toISOString().split("T")[0],// format as YYYY-MM-DD
                                });                               
                               
                              }}
                         
                            >
                              <option value="">Open this select menu</option>
                              {paymentTerms.map((item, i) => {
                                return (
                                  <option value={JSON.stringify(item)}>
                                  {/* <option value={item.id}> 
                                    {item.payTerms}
                                  </option>
                                );
                               
                              })}
                               
                            </select>
                            {/* <img className="pen" src={ic_green_pen} alt="" /> 
                            <div className="invalid-feedback font-11">
                              Please Select Payment Terms
                            </div>
                          </div>
                        </div> */}

                        <div className="date" id="deu-date">
                          <label htmlFor="" className="key">
                            Payment Terms:
                          </label>
                          <div className="d-flex align-items-center">
                            <select
                              id="paymentTerms"
                              className="cald form-control form-control-date ms-2"
                              aria-label="Default select example"
                              name="paymentTerms"
                              value={invoiceFormDetails.paymentTermId || ""}
                              required
                              onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedOption = paymentTerms.find(
                                  (item) => item.id.toString() === selectedId
                                );

                                if (selectedOption) {
                                  const { payTerms, id } = selectedOption;
                                  const paymentTermDays = parseInt(
                                    payTerms,
                                    10
                                  );
                                  const invoiceDate = new Date(
                                    invoiceFormDetails.invoiceDate
                                  );
                                  const dueDate = new Date(invoiceDate);
                                  dueDate.setDate(
                                    dueDate.getDate() + paymentTermDays
                                  );

                                  setInvoiceFormDetails({
                                    ...invoiceFormDetails,
                                    paymentTermId: id,
                                    paymentTerms: payTerms,
                                    dueDate: dueDate
                                      .toISOString()
                                      .split("T")[0], // format as YYYY-MM-DD
                                  });
                                }
                              }}
                            >
                              <option value="">Open this select menu</option>
                              {paymentTerms.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.payTerms}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback font-11">
                              Please Select Payment Terms
                            </div>
                          </div>
                        </div>

                        <div className="deu-date"></div>
                      </div>
                    </div>

                    {formFormat === "left" && (
                      <div className="right-logo logo-back">
                        {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                        <div style={{ textAlign: "center" }}>
                          {/* <input
                          type="file"
                          name=""
                          id="uploadLogo1"
                          className="d-none"
                        /> */}
                          {Dark === "lightMode" ? (
                            <img
                              src={userData?.CompanyLogo}
                              alt=""
                              onError={(e) => e.target.src = Logo}
                            />
                          ) : (
                            <img
                              src={userData?.CompanyLogo}
                              alt=""
                              onError={(e) => e.target.src = Logo}
                            />
                          )}

                          {/* <br /> */}
                          {/* <label
                          style={{ fontSize: "11px" }}
                          htmlFor=""
                          className="text-auth"
                        >
                          Upload your logo here
                        </label> */}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* =========================== Owner details=============================== */}
                <div className="name-details-main">
                  <div className="name-details-inner ">
                    <div className="left">
                      <div className="left-input-info">
                        <input
                          type="text"
                          name="suppName"
                          className="form-control mb-1"
                          value={invoiceFormDetails.suppName}
                          style={{ border: "none", width: "260px" }}
                          id="name"
                          disabled
                        />
                        <textarea
                          name="suppAddr"
                          id="text-area"
                          cols="30"
                          rows="10"
                          className="form-control mb-1"
                          value={invoiceFormDetails.suppAddr}
                          style={{ border: "none", width: "auto" }}
                          disabled
                        />
                        <div className="contact" style={{ width: "280px" }}>
                          <label htmlFor="">Email Id </label>
                          <input
                            type="text"
                            name="suppContactNo"
                            maxLength={10}
                            className="form-control mb-1"
                            value={invoiceFormDetails.suppEmail}
                            style={{ border: "none", width: "206px" }}
                            disabled
                          />
                        </div>
                        <div className="contact">
                          <label htmlFor="">Contact No. </label>
                          <input
                            type="text"
                            name="suppContactNo"
                            className="form-control mb-1"
                            maxLength={10}
                            value={invoiceFormDetails.suppContactNo}
                            style={{ border: "none" }}
                            disabled
                          />
                        </div>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="contact mb-1">
                            <label htmlFor="">GST No.</label>
                            <input
                              type="text"
                              name="suppGSTNo"
                              className="form-control"
                              placeholder=""
                              value={invoiceFormDetails.suppGSTNo}
                              style={{ border: "none" }}
                              disabled
                            />
                          </div>
                        )}
                        <div className="contact mb-1">
                          <label htmlFor="">PAN No.</label>
                          <input
                            type="text"
                            name="suppPANNo"
                            className="form-control"
                            placeholder=""
                            value={invoiceFormDetails.suppPANNo}
                            style={{ border: "none" }}
                            disabled
                          />
                        </div>

                        <div className="mt-2 PON_No">
                          <label htmlFor="" className="key marginttop4 ">
                            P.O No.
                          </label>
                          <div className="input-with-pencile">
                            <input
                              id="PONo"
                              type="text"
                              className="form-control mb-1"
                              value={invoiceFormDetails.PONo}
                              placeholder=""
                              onChange={(e) => {
                                goodsHandleChange("PONo", e);
                              }}
                            />
                          </div>
                        </div>

                        <div className="contact mb-1 PON_No">
                          <label htmlFor="" className="date-owener">
                            Date :
                          </label>
                          <div
                            style={{ marginRight: "20px" }}
                            className="d-flex calender-owener"
                          >
                            <DatePicker
                              id="podate"
                              selected={
                                invoiceFormDetails.podate
                                  ? new Date(invoiceFormDetails.podate)
                                  : new Date()
                              }
                              value={
                                invoiceFormDetails.podate
                                  ? displayDateFormat(
                                    appSettings.dateFormat,
                                    invoiceFormDetails.podate
                                  )
                                  : null
                              }
                              onChange={(date) => {
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  podate: new Date(date)
                                    .toISOString()
                                    .toString(),
                                });
                              }}
                              showYearDropdown
                              placeholderText="Choose a date"
                              className="cald form-control form-control-date ms-2"
                            />
                            {Dark === "lightMode" ? (
                              <img
                                src={calendersvg}
                                className="calendarI"
                                alt=""
                              />
                            ) : (
                              <img
                                src={calendersvg_dark}
                                className="calendarI"
                                alt=""
                              />
                            )}{" "}
                            {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                          </div>
                        </div>

                        {/* {invoiceFormDetails.totalAmount > 50000 && (
                        <div className="mb-2 mt-2 PON_No">
                          <label htmlFor="" className="key marginttop4 ">
                            E-Way Bill No
                          </label>
                          <div className="input-with-pencile">
                            <input
                              id="ewayBillNo"
                              required={
                                invoiceFormDetails.totalAmount > 50000
                                  ? true
                                  : false
                              }
                              disabled={
                                invoiceFormDetails.totalAmount < 50000
                                  ? true
                                  : false
                              }
                              type="text"
                              value={invoiceFormDetails.ewayBillNo}
                              className="form-control mb-1"
                              placeholder="1234567890"
                              onChange={(e) => {
                                goodsHandleChange("ewayBillNo", e);
                              }}
                            />
                            <img className="pen" src={ic_green_pen} alt="" />
                            <div className="invalid-feedback font-11">
                              Please Select E-Way Bill Number
                            </div>
                          </div>
                        </div>
                      )} */}
                      </div>
                    </div>
                    <div className="right">
                      <div className="place-text-right">
                        <div className="mb-4">
                          <label htmlFor="" className="key marginttop4">
                            Place of Supply :
                          </label>
                          <div className="input-with-pencile">
                            <select
                              id="placeOfSupply"
                              className="form-select"
                              aria-label="Default select example"
                              name="placeOfSupply"
                              required
                              disabled={
                                invoiceFormDetails.billGSTNo ||
                                  invoiceFormDetails.billState
                                  ? true
                                  : false
                              }
                              value={invoiceFormDetails.placeOfSupply}
                              onChange={(e) => {
                                goodsHandleChange("placeOfSupply", e);
                              }}
                            >
                              <option value="">Open this select menu</option>
                              {states &&
                                states.map((state) => (
                                  <option
                                    value={`${state.name}-${state.code}`}
                                  >{`${state.name}-${state.code}`}</option>
                                ))}
                            </select>
                            {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please Select Place Of Supply
                            </div>
                          </div>
                        </div>
                        <div className="marginttop4">
                          <label htmlFor="" className="key">
                            Mode of Payment :
                          </label>
                          <div className="input-with-pencile mb-1">
                            <select
                              id="modeOfPay"
                              className="form-select"
                              aria-label="Default select example"
                              name="modeOfPay"
                              required
                              value={invoiceFormDetails.modeOfPay}
                              onChange={(e) => {
                                goodsHandleChange("modeOfPay", e);
                              }}
                            >
                              <option value="">Open this select menu</option>
                              <option value="Cash">Cash</option>
                              <option value="Credit">Credit</option>
                              <option value="Online">Online</option>
                              <option value="Cheque">Cheque</option>
                            </select>
                            {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please Select Mode Of Payment
                            </div>
                          </div>
                        </div>
                        <div className="input-with-pencile mb-1">
                          {invoiceFormDetails.modeOfPay === "Cheque" ? (
                            <>
                              <input
                                id="chequeNo"
                                type="text"
                                name="chequeNo"
                                className="form-control"
                                placeholder="Cheque No. XXX06542"
                                required={
                                  invoiceFormDetails.modeOfPay === "Cheque"
                                    ? true
                                    : false
                                }
                                value={invoiceFormDetails.chequeNo}
                                onChange={(e) => {
                                  goodsHandleChange("chequeNo", e);
                                }}
                              />

                              {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                              <div className="invalid-feedback font-11">
                                Please provide Cheque No.
                              </div>
                            </>
                          ) : null}
                        </div>

                        <div className="input-with-pencile mb-1">
                          {invoiceFormDetails.modeOfPay === "Cheque" ? (
                            <>
                              <input
                                id="bankName"
                                type="text"
                                name="bankName"
                                className="form-control"
                                placeholder="Name of Bank"
                                required={
                                  invoiceFormDetails.modeOfPay === "Cheque"
                                    ? true
                                    : false
                                }
                                value={invoiceFormDetails.bankName}
                                onChange={(e) => {
                                  goodsHandleChange("bankName", e);
                                }}
                              />

                              {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                              <div className="invalid-feedback font-11">
                                Please provide Bank Name
                              </div>
                            </>
                          ) : null}
                        </div>

                        <div className="marginttop4 mt-2">
                          <label htmlFor="" className="key">
                            Mode of Transport 
                          </label>
                          <div className="input-with-pencile mb-1">
                            <select
                              id="modeofTransport"
                              className="form-select"
                              aria-label="Default select example"
                              name="modeofTransport"
                              required
                              value={invoiceFormDetails.modeofTransport}
                              onChange={(e) => {
                                goodsHandleChange("modeofTransport", e);
                              }}
                            >
                              <option value="">
                                Please Select Transport type...
                              </option>
                              <option value="By Road">By Road</option>
                              <option value="By Air">By Air</option>
                              <option value="By Train">By Train</option>
                              <option value="By Hand">By Hand</option>
                            </select>
                            {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please provide Mode Of Transport
                            </div>
                          </div>
                        </div>
                        {/* isSezDeveloper */}

                        {invoiceFormDetails.modeofTransport === "By Road" && (
                          <div className="input-with-pencile mb-1">
                            <input
                              id="vehicleNumber"
                              name="vehicleNumber"
                              type="text"
                              className="form-control"
                              value={invoiceFormDetails.vehicleNumber}
                              placeholder="Vehicle Number"
                              required={
                                invoiceFormDetails.modeofTransport === "By Road"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  vehicleNumber: e.target.value.toUpperCase(),
                                });
                              }}
                            />

                            {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please provide plate No.
                            </div>
                          </div>
                        )}

                        {isSezDeveloper && (
                          <div className="marginttop4 mt-2 d-flex">
                            <input
                              type="checkbox"
                              style={{ marginRight: "7px", width: "11px" }}
                              checked={invoiceFormDetails?.isSEZEnabled}
                              onChange={(e) => {
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  isSEZEnabled: e.target.checked,
                                  lutBondNo: "",
                                });
                                setProductDetails(
                                  productDetails &&
                                  productDetails.map((item, i) => {
                                    return {
                                      ...item,
                                      igst: 0,
                                      igstAmount: 0,
                                      sgst: 0,
                                      sgstAmount: 0,
                                      cgst: 0,
                                      cgstAmount: 0,
                                      gst: 0,
                                    };
                                  })
                                );
                              }}
                            />
                            <label htmlFor="" className="key">
                              Enable SEZ
                            </label>
                          </div>
                        )}

                        {invoiceFormDetails?.isSEZEnabled && (
                          <div className="mt-2 PON_No">
                            <label htmlFor="" className="key marginttop4 ">
                              LUT Bond No
                            </label>
                            <div className="input-with-pencile">
                              <input
                                id="lutBondNo"
                                type="text"
                                required={
                                  invoiceFormDetails?.isSEZEnabled
                                    ? true
                                    : false
                                }
                                className="form-control mb-1"
                                value={invoiceFormDetails?.lutBondNo}
                                placeholder=""
                                onChange={(e) => {
                                  goodsHandleChange("lutBondNo", e);
                                }}
                              />
                              <div className="invalid-feedback font-11">
                                Please provide LUT Bond Number
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="name-details-main" id="info">
                  <div className="name-details-inner">
                    <div className=" left " id="left">
                      <div className="name">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: "18px",
                          }}
                        >
                          <label htmlFor="" id="small-heading">
                            Bill To
                          </label>
                          <div>
                            {/* <img
                              style={{ cursor: "pointer", marginRight: "5px" }}
                              src={removeIcon}
                              title="clear"
                              onClick={() => {
                                copyAndClearBillingAddress("clearBilling");
                              }}
                              alt=""
                            /> */}
                            <img
                              style={{ cursor: "pointer", width: "17px" }}
                              title="copy"
                              src={copyIcon}
                              onClick={() =>
                                copyAndClearBillingAddress("copyShipmentData")
                              }
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="left-input-info">
                        <div className="input-with-pencile">
                          <input
                            id="custName"
                            list="customerNames"
                            type="text"
                            className="form-control mb-1 me-2"
                            placeholder="Name"
                            name="custName"
                            required
                            value={invoiceFormDetails.custName}
                            onChange={(e) => {
                              goodsHandleChange("custName", e);
                              let billNames = nameList?.filter((item, index) => {
                                if (item.first_name === e.target.value) {
                                  return item;
                                }
                              })[0];
                              billNames && getCustomerBillingData(billNames);
                            }}
                          />{" "}

                          <datalist
                            id="customerNames"
                            className="datalist-product"
                          >
                            {nameList &&
                              nameList?.map((item) => {
                                return (
                                  <>
                                    <option>{item.first_name}</option>
                                  </>
                                );
                              })}
                          </datalist>
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please provide Name
                          </div>
                        </div>

                        <div className="input-with-pencile">
                          <textarea
                            id="billAddr"
                            name="billAddr"
                            cols="30"
                            rows="10"
                            className="form-control mb-1  me-2"
                            placeholder="Address"
                            required
                            value={invoiceFormDetails.billAddr}
                            onChange={(e) => {
                              goodsHandleChange("billAddr", e);
                            }}
                            style={{ height: "60px", resize: "none" }}
                          />
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please provide Address
                          </div>
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">City</label>
                          <div className="">
                            <input
                              id="billCity"
                              type="text"
                              name="billCity"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.billCity}
                              onChange={(e) => {
                                goodsHandleChange("billCity", e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Pin</label>
                          <div className="">
                            <input
                              id="billPincode"
                              type="text"
                              name="billPincode"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.billPincode}
                              onChange={(e) => {
                                goodsHandleChange("billPincode", e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Email Id </label>
                          <div className="">
                            <input
                              id="billEmail"
                              type="email"
                              name="billEmail"
                              required
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.billEmail}
                              onChange={(e) => {
                                goodsHandleChange("billEmail", e);
                              }}
                            />
                          </div>
                        </div>

                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Contact No. </label>
                          <div className="">
                            <input
                              id="billContactNo"
                              maxLength={10}
                              type="text"
                              name="billContactNo"
                              required
                              value={invoiceFormDetails.billContactNo}
                              className="form-control mb-1 me-2"
                              onChange={(e) => {
                                const regex = /^[0-9 +\b]+$/;
                                if (
                                  e.target.value == "" ||
                                  regex.test(e.target.value)
                                ) {
                                  goodsHandleChange("billContactNo", e);
                                }
                              }}
                            />
                          </div>
                        </div>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="contact input-with-pencile_1 mb-1">
                            <label htmlFor="">GST No.</label>
                            <div className="">
                              {" "}
                              <input
                                id="billGSTNo"
                                maxLength={15}
                                type="text"
                                name="billGSTNo"
                                pattern="^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}[A-Z\d]{1}$"
                                className="form-control me-2"
                                placeholder="XX-XXXXXX"
                                value={invoiceFormDetails.billGSTNo}
                                onChange={(e) => {
                                  handleInvoiceSearch(e);
                                  setInvoiceFormDetails({
                                    ...invoiceFormDetails,
                                    billGSTNo: e.target.value.toUpperCase(),
                                    billState: "",
                                  });
                                  getDetailsByGstNumber(e.target.value);
                                }}
                              />
                              <div className="invalid-feedback font-11">
                                Please Enter Valid GST Number
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">PAN No.</label>
                          <div className="">
                            <input
                              id="billPANNo"
                              maxLength={10}
                              type="text"
                              name="billPANNo"
                              className="form-control me-2"
                              placeholder="XXXXXXXXXX"
                              value={invoiceFormDetails.billPANNo}
                              onChange={(e) => {
                                goodsHandleChange("billPANNo", e);
                              }}
                            />
                          </div>
                        </div>

                        {invoiceFormDetails.billGSTNo === "" && (
                          <div className="contact input-with-pencile_1 mb-1">
                            <label htmlFor="">State</label>
                            <div className="input-with-pencile">
                              <select
                                style={{ width: "150px", marginRight: "8px" }}
                                // id="placeOfSupply"
                                className="form-select"
                                aria-label="Default select example"
                                name="billState"
                                value={invoiceFormDetails.billState}
                                onChange={(e) => {
                                  setInvoiceFormDetails({
                                    ...invoiceFormDetails,
                                    billState: e.target.value,
                                    // placeOfSupply: e.target.value,
                                  });
                                }}
                              >
                                <option value="">Select state</option>
                                {states &&
                                  states.map((state) => (
                                    <option
                                      value={`${state.name}-${state.code}`}
                                    >{`${state.name}-${state.code}`}</option>
                                  ))}
                              </select>
                              {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                              {/* <div className="invalid-feedback font-11">
                                  Please Select Place Of Supply
                                </div> */}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" left " id="left">
                      <div className="name">
                        <label
                          htmlFor=""
                          id="small-heading"
                          className="marginttop4"
                        >
                          Ship To
                        </label>
                        {/* <img
                          style={{ marginLeft: "60%", cursor: "pointer" }}
                          title="clear"
                          src={removeIcon}
                          onClick={() => {
                            copyAndClearBillingAddress("clearShipment");
                          }}
                          alt=""
                        /> */}
                      </div>
                      <div className="left-input-info">
                        <div className="input-with-pencile">
                          <input
                            id="shipCustName"
                            type="text"
                            name="shipCustName"
                            className="form-control mb-1 me-2"
                            placeholder="Name"
                            // required
                            value={invoiceFormDetails.shipCustName}
                            onChange={(e) => {
                              goodsHandleChange("shipCustName", e);
                            }}
                          />{" "}
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                          {/* <div className='invalid-feedback font-11'>
                          Please provide Name
                        </div> */}
                        </div>

                        <div className="input-with-pencile">
                          <textarea
                            id="shipAddr"
                            name="shipAddr"
                            cols="30"
                            rows="10"
                            className="form-control mb-1  me-2"
                            placeholder="Address"
                            // required
                            value={invoiceFormDetails.shipAddr}
                            onChange={(e) => {
                              goodsHandleChange("shipAddr", e);
                            }}
                            style={{ height: "60px", resize: "none" }}
                          />
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}

                          {/* <div className='invalid-feedback font-11'>
                          Please provide Address
                        </div> */}
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">City</label>
                          <div className="">
                            <input
                              id="shipCity"
                              type="text"
                              name="shipCity"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.shipCity}
                              onChange={(e) => {
                                goodsHandleChange("shipCity", e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Pin</label>
                          <div className="">
                            <input
                              id="shipPincode"
                              type="text"
                              name="shipPincode"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.shipPincode}
                              onChange={(e) => {
                                goodsHandleChange("shipPincode", e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Email Id </label>
                          <div className="">
                            <input
                              id="shipEmail"
                              type="email"
                              name="shipEmail"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.shipEmail}
                              onChange={(e) => {
                                goodsHandleChange("shipEmail", e);
                              }}
                            />
                          </div>
                        </div>

                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">Contact No. </label>
                          <div className="">
                            <input
                              id="shipContactNo"
                              maxLength={10}
                              type="text"
                              name="shipContactNo"
                              className="form-control mb-1 me-2"
                              value={invoiceFormDetails.shipContactNo}
                              onChange={(e) => {
                                const regex = /^[0-9\b]+$/;
                                if (
                                  e.target.value == "" ||
                                  regex.test(e.target.value)
                                ) {
                                  goodsHandleChange("shipContactNo", e);
                                }
                              }}
                            />
                          </div>
                        </div>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="contact input-with-pencile_1 mb-1">
                            <label htmlFor="">GST No.</label>
                            <div className="">
                              {" "}
                              <input
                                id="shipGSTNo"
                                maxLength={15}
                                type="text"
                                name="shipGSTNo"
                                pattern="^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}[A-Z\d]{1}$"
                                className="form-control me-2"
                                placeholder="XX-XXXXXXXXXX"
                                value={invoiceFormDetails.shipGSTNo}
                                onChange={(e) => {
                                  handleInvoiceSearch(e);
                                  setInvoiceFormDetails({
                                    ...invoiceFormDetails,
                                    shipGSTNo: e.target.value.toUpperCase(),
                                  });
                                  getDetailsByGstNumber(
                                    e.target.value,
                                    "shipGSTNumber"
                                  );
                                }}
                              />
                              <div className="invalid-feedback font-11">
                                Please Enter Valid GST Number
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">PAN No.</label>
                          <div className="">
                            <input
                              id="shipPANNo"
                              maxLength={10}
                              type="text"
                              name="shipPANNo"
                              className="form-control me-2"
                              placeholder="XXXXXXXXXX"
                              value={invoiceFormDetails.shipPANNo}
                              onChange={(e) => {
                                goodsHandleChange("shipPANNo", e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Product Table */}
                <div className="detail-table-main responsiveTable">
                  <ProductTable
                    isStateSame={isStateSame}
                    productDetails={productDetails}
                    setProductDetails={setProductDetails}
                    units={units}
                    addNewRow={addNewRow}
                    setBackDropOpen={setBackDropOpen}
                    permissions={permissions}
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    DeleteHandler={DeleteHandler}
                    currentRoute={currentRoute}
                    appSettings={appSettings}
                    invoiceFormDetails={invoiceFormDetails}
                  />
                </div>

                <div className="sub-total-section">
                  <div className="left">
                    <div className="text-sub">
                      <label htmlFor="">Sub Total</label>
                    </div>
                    {appSettings &&
                      appSettings?.isGSTApplicable &&
                      (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (
                      <div className="text-sub">
                        <label htmlFor="">IGST</label>
                      </div>
                    ) : (
                      <>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="text-sub">
                            <label htmlFor="">CGST</label>
                          </div>
                        )}
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="text-sub">
                            <label htmlFor="">SGST</label>
                          </div>
                        )}
                      </>
                    )}
                    {appSettings && appSettings.isRoundOff && (
                      <div className="text-sub">
                        <label htmlFor="">Round off</label>
                      </div>
                    )}
                  </div>

                  <div className="right">
                    <div className="sub-total">
                      <label htmlFor="">
                        ₹
                        {invoiceFormDetails.subTotal
                          ? parseFloat(invoiceFormDetails.subTotal).toFixed(2)
                          : 0}{" "}
                      </label>
                    </div>
                    {appSettings &&
                      appSettings?.isGSTApplicable &&
                      (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (
                      <div className="sub-total">
                        <label htmlFor="">
                          ₹{" "}
                          {invoiceFormDetails.igstAmount
                            ? parseFloat(invoiceFormDetails.igstAmount).toFixed(
                              2
                            )
                            : 0}
                        </label>
                      </div>
                    ) : (
                      <>
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="sub-total">
                            <label htmlFor="">
                              ₹{" "}
                              {invoiceFormDetails.cgstAmount
                                ? parseFloat(
                                  invoiceFormDetails.cgstAmount
                                ).toFixed(2)
                                : 0}
                            </label>
                          </div>
                        )}
                        {appSettings && appSettings.isGSTApplicable && (
                          <div className="sub-total">
                            <label htmlFor="">
                              ₹{" "}
                              {invoiceFormDetails.sgstAmount
                                ? parseFloat(
                                  invoiceFormDetails.sgstAmount
                                ).toFixed(2)
                                : 0}
                            </label>
                          </div>
                        )}
                      </>
                    )}
                    {appSettings && appSettings.isRoundOff && (
                      <div className="sub-total">
                        <label htmlFor="">
                          {invoiceFormDetails.roundOff
                            ? invoiceFormDetails.roundOff
                            : 0}
                        </label>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mainsub-total"></div>
                <div className="total-amt-main">
                  <div className="sub-total-section" id="sub-total-section">
                    <div className="left">
                      <div className="text-sub">
                        <label htmlFor="">Total Amount</label>
                      </div>
                    </div>
                    <div className="right">
                      <div className="sub-total">
                        <label htmlFor="">
                          ₹
                          {invoiceFormDetails.totalAmount
                            ? commaNumber(
                              Math.floor(
                                invoiceFormDetails.totalAmount
                              ).toFixed(2)
                            )
                            : 0}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="in-word">
                    <label htmlFor="">{amountInWords}</label>
                  </div>
                </div>
                <div className="line-total"></div>
                <div className="disc-sign-main row">
                  <div className="col-lg-7 left ps-0">
                    {/* <div className="description">
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      placeholder="Declaration"
                      name="declaration"
                    ></textarea>
                  </div> */}
                    {/* <p></p> */}
                    <div className="Terms-of-Services">
                      <div className="heading-TS">
                        <label htmlFor="">Terms and Conditions</label>
                      </div>
                      <div className="term-conditions">
                        {logo?.terms ? logo.terms : ""}
                      </div>
                      {/* <ul>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                    </ul> */}
                    </div>
                  </div>
                  <div className="col-lg-5 right pe-0">
                    <label
                      className="upload d-block"
                      htmlFor="uploadLogo"
                      style={{ cursor: "pointer" }}
                    >
                      {/* <input
                      type="file"
                      name="authsign"
                      id="uploadLogo"
                      className="d-none"
                      onChange={(e) => {
                        setInvoiceFormDetails({
                          ...invoiceFormDetails,
                          authsign: e.target.files[0],
                        });
                      }}
                    /> */}
                      {logo.signtureLogo ? (
                        <img
                          src={logo.signtureLogo ? logo.signtureLogo : ""}
                          alt=""
                        />
                      ) : null}

                      {/* <br />
                    <label htmlFor="" className="text-up">
                      Upload your signature
                    </label> */}
                      <br />
                      <label htmlFor="" className="text-auth">
                        Authorized Signature
                      </label>
                    </label>
                  </div>
                </div>
              </div>
              {formFormat === "bottom" && (
                <div className="middle-top-logo text-center pb-3 mt-4">
                  {/* <div className="logo-top-left">
                <div className="pt-4">
                  {Dark === "lightMode" ? (
                    <img src={ic_upload} alt="" />
                  ) : (
                    <img src={ic_upload_dark} alt="" />
                  )}{" "}
                  <div className="up-text">
                    <label htmlFor="">Upload your logo here</label>
                  </div>
                </div>
              </div> */}
                  <div className="right-logo logo-back">
                    <div className="img-right img">
                      {/* <img src={rb_logo} alt="" /> */}
                      <img
                        src={userData?.CompanyLogo}
                        alt=""
                        onError={(e) => e.target.src = Logo}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="text-end">
                {/* <button className="form-submit-btn" type="submit">
                Submit
              </button> */}
                <button
                  disabled={loading ? true : false}
                  className="form-submit-btn"
                  type="submit"
                  onClick={getFocus}
                  style={{ width: "98px", height: "29px", textAlign: "center" }}
                >
                  {loading ? (
                    <div
                      className="spinner-border text-secondar"
                      role="status"
                      style={{ width: "1rem", height: "1rem", margin: "-2 -2" }}
                    >
                      <span className="sr-only mt-3"></span>
                    </div>
                  ) : invoiceAction === "edit" ? (
                    "Update"
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        </FormGroup>
      </Form>

      {/* Modal Of Add new row*/}
      {/* <Modal
        show={addedNew}
        size="lg"
        onHide={() => setAddedNew(false)}
        centered
        className="main-add-row-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            New Product
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form noValidate validated={productValidated} onSubmit={handleSubmit}>
            <div className="add-row-content-modal">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Code
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productCode: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row "
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productName: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product name.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Unit Price
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          rate: Number(e.target.value),
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Unit Price.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Account
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          ledgerAccId: Number(e.target.value),
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {account &&
                        account.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide an Account.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      HSN Code
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          hsnId: Number(e.target.value),
                          hsnCode: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].hsnCode,
                          taxRate: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].taxRate,
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {hsnCodes &&
                        hsnCodes.map((code) => (
                          <option value={code.id} key={code.id}>
                            {code.hsnCode}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide HSN Code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4 mt-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Tax Rate
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control input-add-row"
                      disabled
                      value={newProduct.taxRate}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Tax Rate
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              
              <Modal.Footer className="mt-4">
                <Link
                  to="#"
                  className="cancelbtn text-center"
                  onClick={() => setAddedNew(false)}
                >
                  Cancel
                </Link>
                <button className="savebtn text-center" type="submit">
                  Save
                </button>
              </Modal.Footer>
            </div>
          </Form>
        </Modal.Body>
      </Modal> */}
    </main>
  );
};

export default SalesGoodsForm;
